export const en = {
    'error.user-get.title': 'An error occurred while obtaining user data',
    'error.user-get.description': 'You can write a report in the bug',
    'default-title': 'Khural',
};
